import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

interface IKey {
    api_key?: string
    balance?: number
    exchange?: string
    is_active?: boolean
    is_copy_bot?: boolean
    key_id?: string
    name?: string
    ip_set?: string
    type?: string
    pro_ip_set?: string
}

export interface IUserData {
    Keys?: IKey[]
    active_exchanges?: any
    change_count?: number
    created_at?: number
    email?: string
    email_confirmed?: boolean
    followers?: number
    following?: number
    has_password?: boolean
    id?: string
    my_referral_code?: string
    name?: string
    network?: string
    nicknames?: {language?: string; nickname?: string}[]
    phone?: string
    phone_confirmed?: boolean
    privacy_level?: number
    status?: string
    thumbnail?: string
    is_filtered?: boolean
    referral_user_count?: number
    type?: number
    used_referral_code?: {
        id: string
        name: string
        thumbnail: string
    }
    wallets?: IWallets
    is_pro?: boolean
    pro_until?: string
    league_points?: number
    active_league?: IUserActiveLeague[]
}

export interface IUserActiveLeague {
    id: string
    user_id: string
    league_id: string
    is_active: boolean
    is_remove?: boolean
    created_at: number
    updated_at: number
    initial_balance: {
        key_id: string
        assets: {
            symbol: string
            amount: number
            price_in_base: number
        }[]
        total_in_base: number
    }[]
}

export interface IWallets {
    wallets?: SimpleWallet[]
    total_value?: number
}

export interface SimpleWallet {
    id?: string
    coin: string
    balance: number
    price: number
    value?: number
    logo?: string
}

export const getUserDetail = async (id: string): Promise<ApiRes<IUserData>> => {
    if (!id) return
    return await apiGet(API_URL, `admin/user/${id}`)
}
